import {
    RESET_SUBUSER_PASSWORD_OPEN_MODAL,
    RESET_SUBUSER_PASSWORD_CLOSE_MODAL,
    RESET_SUBUSER_PASSWORD_REQUEST,
    RESET_SUBUSER_PASSWORD_RESULT,
} from 'Redux/actionTypes';

export const resetSubUserPasswordOpenModal = (data) => ({
    type: RESET_SUBUSER_PASSWORD_OPEN_MODAL,
    payload: data
})

export const resetSubUserPasswordCloseModal = () => ({
    type: RESET_SUBUSER_PASSWORD_CLOSE_MODAL
})

export const resetSubUserPasswordRequest = (data) => ({
    type: RESET_SUBUSER_PASSWORD_REQUEST,
    payload: data
})

export const resetSubUserPasswordResult = (result) => ({
    type: RESET_SUBUSER_PASSWORD_RESULT,
    payload: result
})